export const translations = {
  en: {
    brand: 'lyomastech',
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      contact: 'Contact',
      cta: 'Get a quote',
    },
    home: {
      eyebrow: 'Software studio · Cairo / Remote',
      h1_a: 'We build',
      h1_b: 'serious',
      h1_c: 'software for',
      h1_d: 'modern business.',
      sub: 'LyomasTech is a software studio crafting bespoke ERP accounting systems and high-performance web applications for ambitious teams.',
      cta_primary: 'Start a project',
      cta_secondary: 'See our work',
      scroll: 'scroll',
      marquee: 'Built with',
      stats_title: 'Numbers that speak',
      stats_projects: 'Projects shipped',
      stats_clients: 'Happy clients',
      stats_years: 'Years of craft',
      stats_team: 'People on the team',
      services_eyebrow: 'What we do',
      services_title: 'Two specialties. Deep expertise.',
      service_erp_title: 'ERP & Accounting',
      service_erp_desc: 'Full-featured accounting, inventory, invoicing, payroll and financial reporting — built around your workflow.',
      service_web_title: 'Web Development',
      service_web_desc: 'Fast, beautiful, accessible web apps and marketing sites. React, Next.js, FastAPI — production-grade.',
      learn_more: 'Learn more',
      why_eyebrow: 'Why teams pick us',
      why_title: 'Engineering with taste.',
      why_desc: 'We are a tight-knit team that obsesses over the details. Every line of code, every pixel, every interaction — designed to make your business move faster.',
      why_1: 'Bilingual delivery. We ship in Arabic and English with proper RTL.',
      why_2: 'Direct line to your engineers. No agency middlemen.',
      why_3: 'Production-ready, maintainable code. No throwaway demos.',
      why_4: 'Honest scoping. Real timelines. No surprises.',
    },
    services: {
      eyebrow: 'Capabilities',
      title: 'Our capabilities, in detail.',
      sub: 'Two services, executed at a very high standard.',
      erp_heading: 'ERP Accounting Software',
      erp_intro: 'A complete accounting platform tailored to your business. Built once, scales forever.',
      erp_features: [
        'General Ledger & Chart of Accounts',
        'Invoicing & Accounts Receivable',
        'Bills & Accounts Payable',
        'Inventory & Warehouse Management',
        'Payroll & HR essentials',
        'Multi-currency & Tax/VAT compliance',
        'Financial Reports & Dashboards',
        'Role-based Access Control',
      ],
      web_heading: 'Web Development',
      web_intro: 'Sites and apps that load fast, look stunning, and convert.',
      web_features: [
        'Landing pages & marketing sites',
        'SaaS dashboards & admin panels',
        'E-commerce storefronts',
        'Internal tools & portals',
        'API & integration work',
        'SEO, analytics & performance',
        'Mobile-first responsive design',
        'Bilingual (AR/EN) with RTL',
      ],
      cta_title: 'Have a project in mind?',
      cta_sub: 'Tell us what you need. We reply within one business day.',
    },
    portfolio: {
      eyebrow: 'Selected work',
      title: 'A few things we shipped.',
      sub: 'Real systems running in real businesses.',
      items: [
        { title: 'Falcon ERP', cat: 'ERP · Retail', desc: 'Multi-branch retail ERP for a 30-store chain.' },
        { title: 'Zayn Books', cat: 'Accounting · SaaS', desc: 'Cloud accounting for SMBs with full VAT compliance.' },
        { title: 'Mawsim', cat: 'E-commerce', desc: 'High-conversion storefront with bilingual checkout.' },
        { title: 'Nexora Dashboard', cat: 'SaaS · Web', desc: 'Operational dashboards for a logistics platform.' },
        { title: 'Bayt Invoicing', cat: 'FinTech', desc: 'Lightweight invoicing app for freelancers.' },
        { title: 'Tariq Portal', cat: 'Internal Tools', desc: 'Internal portal for a government contractor.' },
      ],
    },
    about: {
      eyebrow: 'Our story',
      title: 'Small team. Big ambition.',
      p1: 'LyomasTech started with one belief: software should feel honest, fast, and beautifully made. We pair the discipline of a product team with the taste of a design studio.',
      p2: 'We have shipped ERP systems for retail chains, accounting platforms for accountants, and modern web apps for founders who refuse to settle for templates.',
      p3: 'If you care about the details, you will feel at home with us.',
      values_title: 'What we value',
      v1_title: 'Craft',
      v1_desc: 'We sweat the details so you do not have to.',
      v2_title: 'Speed',
      v2_desc: 'Clear scope, weekly demos, fast iteration.',
      v3_title: 'Honesty',
      v3_desc: 'Real estimates. Real tradeoffs. No fluff.',
      v4_title: 'Partnership',
      v4_desc: 'We work with you, not just for you.',
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Tell us about your project.',
      sub: 'We reply within one business day. Or chat with our AI assistant for instant answers.',
      name: 'Your name',
      email: 'Email address',
      phone: 'Phone (optional)',
      company: 'Company (optional)',
      service: 'What do you need?',
      service_erp: 'ERP / Accounting',
      service_web: 'Web Development',
      service_other: 'Other',
      message: 'Tell us more',
      send: 'Send message',
      sending: 'Sending…',
      success: 'Thanks! We will get back to you within 24 hours.',
      error: 'Something went wrong. Please try again.',
      info_title: 'Other ways to reach us',
      email_label: 'Email',
      hours_label: 'Office hours',
      hours_value: 'Sun – Thu · 9:00 – 18:00 (Cairo)',
      location_label: 'Based in',
      location_value: 'Cairo, Egypt · Working globally',
    },
    chatbot: {
      title: 'Lyo · AI Assistant',
      subtitle: 'Ask about our services, pricing or process.',
      placeholder: 'Type your message…',
      send: 'Send',
      open: 'Chat with us',
      close: 'Close chat',
      thinking: 'Thinking',
      welcome: "Hi! I'm Lyo, LyomasTech's AI assistant. Ask me anything about our ERP or web work — or tell me about your project.",
      error: 'Connection error. Please try again.',
    },
    footer: {
      tagline: 'Software studio crafting ERP and web for ambitious teams.',
      explore: 'Explore',
      legal: 'Legal',
      contact: 'Contact',
      privacy: 'Privacy',
      terms: 'Terms',
      rights: 'All rights reserved.',
    },
  },
  ar: {
    brand: 'لايوماستيك',
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      portfolio: 'أعمالنا',
      about: 'من نحن',
      contact: 'تواصل معنا',
      cta: 'اطلب عرض سعر',
    },
    home: {
      eyebrow: 'استوديو برمجيات · القاهرة / عن بُعد',
      h1_a: 'نصمم',
      h1_b: 'برمجيات',
      h1_c: 'احترافية',
      h1_d: 'للأعمال الحديثة.',
      sub: 'لايوماستيك استوديو برمجيات متخصص في تطوير أنظمة محاسبة ERP وتطبيقات ويب عالية الأداء للفرق الطموحة.',
      cta_primary: 'ابدأ مشروعك',
      cta_secondary: 'شاهد أعمالنا',
      scroll: 'مرّر',
      marquee: 'نبني باستخدام',
      stats_title: 'أرقام تتكلم',
      stats_projects: 'مشروع تم تسليمه',
      stats_clients: 'عميل سعيد',
      stats_years: 'سنوات من الخبرة',
      stats_team: 'فرد في الفريق',
      services_eyebrow: 'ما نقدمه',
      services_title: 'تخصصان. خبرة عميقة.',
      service_erp_title: 'محاسبة و ERP',
      service_erp_desc: 'نظام محاسبة ومخزون وفواتير ومرتبات وتقارير مالية متكاملة، مصمم حول طريقة عملك.',
      service_web_title: 'تطوير ويب',
      service_web_desc: 'مواقع وتطبيقات ويب سريعة وأنيقة وسهلة الاستخدام. React و Next.js و FastAPI بجودة إنتاج.',
      learn_more: 'اعرف المزيد',
      why_eyebrow: 'لماذا نحن',
      why_title: 'هندسة بذوق رفيع.',
      why_desc: 'فريق صغير متماسك مهووس بالتفاصيل. كل سطر كود وكل بكسل وكل تفاعل مصمم ليجعل عملك يتحرك أسرع.',
      why_1: 'تسليم ثنائي اللغة. عربي وإنجليزي مع دعم RTL كامل.',
      why_2: 'تواصل مباشر مع المهندسين. بدون وسطاء.',
      why_3: 'كود جاهز للإنتاج وقابل للصيانة. لا مشاريع تجريبية.',
      why_4: 'تقدير صادق. مواعيد حقيقية. بدون مفاجآت.',
    },
    services: {
      eyebrow: 'إمكانياتنا',
      title: 'إمكانياتنا بالتفصيل.',
      sub: 'خدمتان نقدمهما بأعلى مستوى.',
      erp_heading: 'برنامج محاسبة ERP',
      erp_intro: 'منصة محاسبة متكاملة مصممة لعملك. تُبنى مرة وتدوم.',
      erp_features: [
        'دفتر الأستاذ ودليل الحسابات',
        'الفواتير والذمم المدينة',
        'المصروفات والذمم الدائنة',
        'إدارة المخازن والمخزون',
        'الرواتب وشؤون الموظفين',
        'متعدد العملات ومتوافق مع الضريبة وVAT',
        'تقارير ولوحات مالية',
        'صلاحيات وأدوار المستخدمين',
      ],
      web_heading: 'تطوير الويب',
      web_intro: 'مواقع وتطبيقات تُحمَّل بسرعة، تبدو رائعة، وتحقق النتائج.',
      web_features: [
        'صفحات هبوط ومواقع تسويقية',
        'لوحات SaaS وأنظمة إدارة',
        'متاجر إلكترونية',
        'أدوات وبوابات داخلية',
        'تطوير APIs وربط الأنظمة',
        'SEO وتحليلات وأداء',
        'تصميم متجاوب بأولوية الجوال',
        'ثنائي اللغة (عربي/إنجليزي) مع RTL',
      ],
      cta_title: 'عندك مشروع في بالك؟',
      cta_sub: 'كلمنا عن احتياجك. هنرد عليك خلال يوم عمل واحد.',
    },
    portfolio: {
      eyebrow: 'أعمال مختارة',
      title: 'بعض ما أنجزناه.',
      sub: 'أنظمة حقيقية تعمل في شركات حقيقية.',
      items: [
        { title: 'فالكون ERP', cat: 'ERP · تجزئة', desc: 'نظام ERP لسلسلة 30 فرع.' },
        { title: 'زين بوكس', cat: 'محاسبة · SaaS', desc: 'محاسبة سحابية للشركات الصغيرة مع توافق VAT.' },
        { title: 'موسم', cat: 'تجارة إلكترونية', desc: 'متجر إلكتروني بمعدل تحويل عالٍ ودفع ثنائي اللغة.' },
        { title: 'نيكسورا داشبورد', cat: 'SaaS · ويب', desc: 'لوحات تشغيل لمنصة لوجستية.' },
        { title: 'بيت للفواتير', cat: 'تكنولوجيا مالية', desc: 'تطبيق فواتير خفيف للمستقلين.' },
        { title: 'بوابة طارق', cat: 'أدوات داخلية', desc: 'بوابة داخلية لمتعهد حكومي.' },
      ],
    },
    about: {
      eyebrow: 'قصتنا',
      title: 'فريق صغير. طموح كبير.',
      p1: 'لايوماستيك بدأت بإيمان واحد: البرمجيات لازم تكون صادقة وسريعة ومصممة بإتقان. بنجمع بين انضباط فريق منتج وذوق استوديو تصميم.',
      p2: 'سلّمنا أنظمة ERP لسلاسل تجزئة، ومنصات محاسبة للمحاسبين، وتطبيقات ويب حديثة لمؤسسين بيرفضوا القوالب الجاهزة.',
      p3: 'لو بتهتم بالتفاصيل، هتحس إنك في بيتك معانا.',
      values_title: 'قيمنا',
      v1_title: 'إتقان',
      v1_desc: 'نحن نهتم بالتفاصيل عشان مش تضطر إنت.',
      v2_title: 'سرعة',
      v2_desc: 'نطاق واضح، عروض أسبوعية، تكرارات سريعة.',
      v3_title: 'صدق',
      v3_desc: 'تقديرات حقيقية. مقايضات حقيقية. بدون حشو.',
      v4_title: 'شراكة',
      v4_desc: 'نشتغل معاك، مش لك بس.',
    },
    contact: {
      eyebrow: 'تواصل',
      title: 'كلمنا عن مشروعك.',
      sub: 'هنرد عليك خلال يوم عمل واحد. أو تحدث مع مساعدنا الذكي لإجابات فورية.',
      name: 'اسمك',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف (اختياري)',
      company: 'الشركة (اختياري)',
      service: 'ايه اللي محتاجه؟',
      service_erp: 'محاسبة / ERP',
      service_web: 'تطوير ويب',
      service_other: 'غير ذلك',
      message: 'احكيلنا أكتر',
      send: 'إرسال',
      sending: 'جاري الإرسال…',
      success: 'شكراً! هنرجعلك خلال 24 ساعة.',
      error: 'حصلت مشكلة. حاول مرة تانية.',
      info_title: 'طرق أخرى للتواصل',
      email_label: 'بريد إلكتروني',
      hours_label: 'مواعيد العمل',
      hours_value: 'الأحد – الخميس · 9:00 – 18:00 (القاهرة)',
      location_label: 'مقرنا',
      location_value: 'القاهرة، مصر · نعمل عالميًا',
    },
    chatbot: {
      title: 'لايو · مساعد ذكي',
      subtitle: 'اسأل عن خدماتنا أو الأسعار أو طريقة العمل.',
      placeholder: 'اكتب رسالتك…',
      send: 'إرسال',
      open: 'تحدث معنا',
      close: 'إغلاق',
      thinking: 'يفكر',
      welcome: 'أهلاً! أنا لايو، المساعد الذكي للايوماستيك. اسألني أي حاجة عن أنظمة ERP أو تطوير الويب — أو احكيلي عن مشروعك.',
      error: 'خطأ في الاتصال. حاول مرة تانية.',
    },
    footer: {
      tagline: 'استوديو برمجيات يصمم أنظمة ERP وتطبيقات ويب للفرق الطموحة.',
      explore: 'استكشف',
      legal: 'قانوني',
      contact: 'تواصل',
      privacy: 'الخصوصية',
      terms: 'الشروط',
      rights: 'كل الحقوق محفوظة.',
    },
  },
};
